import { LoaderFunction, replace } from 'react-router-dom';
import { fetchSignupStep } from '@/features/Signup/api/requests';

export type LoaderData<TLoaderFn extends LoaderFunction> =
  Awaited<ReturnType<TLoaderFn>> extends Response | infer D ? D : never;

export const signupLoader = (async () => {
  const token = localStorage.getItem('token');
  if (token) {
    const response = await fetchSignupStep(token);
    if (typeof response?.step === 'number') {
      return response.step;
    } else if (response && response.step === null) {
      return replace('/cabinet', { status: 301 });
    } else {
      // 0 - initial step
      return 0;
    }
  } else {
    // 0 - initial step
    return 0;
  }
}) satisfies LoaderFunction;
